interface TokensTabProps {
	balance: number;
}

export const TokensTab: React.FC<TokensTabProps> = ({ balance }) => (
	<div className="bg-[#231F20] p-3 md:p-4 rounded-lg">
		<div className="flex items-center justify-between">
			<span className="text-[#FFF1E9] text-sm">SOL</span>
			<span className="text-[#FFF1E9] text-sm">{balance.toFixed(4)}</span>
		</div>
	</div>
);
